/* @flow */
/* Do not edit - Generated by iconify. See README.md for more details. */
/* eslint-disable max-len */
import type { ElementConfig as ReactElementConfig } from "react"

import BaseIcon from "./BaseIcon";

export default class SvgIconPhoneSolid extends BaseIcon {
    static defaultProps: ReactElementConfig<typeof BaseIcon> = {
        iconClass: "PhoneSolidIcon",
    }

    svgContent: string = `<svg class='${this.classNames}' xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 64 64" xml:space="preserve"><path d="M40.3,45.2c-6.4,0-12.6-2.6-17.1-7.1c-4.6-4.6-7.1-10.9-7.1-17.4c0-0.2,0.3-1.5,0.9-2.1l1.9-2c1-1,2.8-1.4,4.2-1l0.4,0.1 c1.3,0.4,2.6,1.8,2.9,3.1l1,3.6c0.4,1.4-0.1,3.2-1.1,4.2l-0.7,0.7c-0.1,0.1-0.1,0.2-0.1,0.4c1.3,3.7,4.2,6.6,7.9,7.9 c0.1,0,0.3,0,0.4-0.1l0.7-0.7c1-1,2.8-1.5,4.2-1.1l3.6,1c1.3,0.4,2.7,1.6,3.1,3l0.1,0.4c0.5,1.4,0,3.2-1,4.2c0,0,0,0,0,0l-2,2 c-0.6,0.6-2,0.9-2.2,0.9C40.5,45.2,40.4,45.2,40.3,45.2z"></path></svg>`;
}